// Implementation inspired by https://www.campbellsci.asia/blog/convert-wind-directions#:~:text=To%20convert%20degrees%20to%20compass,degrees%20instead%20of%2022.5%20degrees.
/**
 * Should match keys from @weenat/intl
 */
export const windDirections = [
    'north',
    'northeast',
    'east',
    'southeast',
    'south',
    'southwest',
    'west',
    'northwest'
];
/** Note that north may be represented by both 0 and 360 degrees */
const compass = [
    'north',
    'northeast',
    'east',
    'southeast',
    'south',
    'southwest',
    'west',
    'northwest',
    'north'
];
/** The number of degrees a direction may span */
const directionDegreeSpanning = 360 / (compass.length - 1);
export const fromWindAngleToDirection = (rawAngle) => {
    /** Be sure to not get values above 360, this does not hurt */
    const degree = rawAngle % 360;
    const directionIndexInsideCompass = Math.round(degree / directionDegreeSpanning);
    return compass[directionIndexInsideCompass];
};
